import { RoutesTabbarFactory } from '../components';

import { TICKET_TYPE_CONFIG } from '../config';

export const TABS_CONFIG = [
  {
    key: TICKET_TYPE_CONFIG['etc-tickets'].key,
    title: TICKET_TYPE_CONFIG['etc-tickets'].name,
  },
  {
    key: TICKET_TYPE_CONFIG['highway-maintenance-fee-tickets'].key,
    title: TICKET_TYPE_CONFIG['highway-maintenance-fee-tickets'].name,
  },
  {
    key: TICKET_TYPE_CONFIG['compulsory-insurance-penalty-tickets'].key,
    title: TICKET_TYPE_CONFIG['compulsory-insurance-penalty-tickets'].name,
  },
  {
    key: TICKET_TYPE_CONFIG['highway-maintenance-fee-penalty-tickets'].key,
    title: TICKET_TYPE_CONFIG['highway-maintenance-fee-penalty-tickets'].name,
  },
] as const;
const TYPE_ROUTE_PARAM = 'type';

const [useTabBar, Tabbar, TabPanel] = RoutesTabbarFactory(
  TABS_CONFIG.map(({ key }) => key),
  TYPE_ROUTE_PARAM,
);

export { useTabBar, Tabbar, TabPanel };
